import React, { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiArrowUpRight, FiMenu, FiX } from 'react-icons/fi';
import Icon from '../../assets/icon.svg';

export const HomeBrand = () => (
  <Link to="/#home" className="home-brand" aria-label="AppActs home">
    <img src={Icon} alt="" width="30" height="30" />
    <span>AppActs<span className="home-brand-dot">.</span></span>
  </Link>
);

const links = [['products', 'Products'], ['how-it-works', 'How it works'], ['pricing', 'Pricing'], ['docs', 'Resources']];

export default function HomeHeader({ user }) {
  const [open, setOpen] = useState(false);
  const headerRef = useRef(null);
  const toggleRef = useRef(null);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (event) => {
      if (event.key === 'Escape') {
        setOpen(false);
        toggleRef.current?.focus();
      }
    };
    const onPointerDown = (event) => {
      if (!headerRef.current?.contains(event.target)) setOpen(false);
    };
    const desktop = window.matchMedia('(min-width: 901px)');
    const onResize = () => { if (desktop.matches) setOpen(false); };
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('pointerdown', onPointerDown);
    desktop.addEventListener('change', onResize);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('pointerdown', onPointerDown);
      desktop.removeEventListener('change', onResize);
    };
  }, [open]);

  return (
    <header className="home-header" ref={headerRef}>
      <div className="home-container home-header-inner">
        <HomeBrand />
        <nav className="home-desktop-nav" aria-label="Main navigation">
          {links.map(([id, label]) => <a key={id} href={`#${id}`}>{label}</a>)}
        </nav>
        <div className="home-header-actions">
          {!user && <Link className="home-login" to="/login">Log in</Link>}
          <Link className="home-button home-button-small" to={user ? '/dashboard' : '/register'}>
            {user ? 'Dashboard' : 'Get started'} <FiArrowUpRight aria-hidden="true" />
          </Link>
          <button className="home-menu-toggle" type="button" ref={toggleRef}
            aria-expanded={open} aria-controls="home-mobile-nav" aria-label={open ? 'Close navigation' : 'Open navigation'}
            onClick={() => setOpen(!open)}>
            {open ? <FiX /> : <FiMenu />}
          </button>
        </div>
      </div>
      <nav id="home-mobile-nav" className="home-mobile-nav" aria-label="Mobile navigation" hidden={!open}>
        {links.map(([id, label]) => <a key={id} href={`#${id}`} onClick={() => setOpen(false)}>{label}<FiArrowUpRight aria-hidden="true" /></a>)}
        {!user && <Link to="/login" onClick={() => setOpen(false)}>Log in <FiArrowUpRight aria-hidden="true" /></Link>}
      </nav>
    </header>
  );
}
